import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lock-status',
  templateUrl: './lock-status.component.html',
  styleUrls: ['./lock-status.component.scss']
})
export class LockStatusComponent implements OnInit {
  @Input() visible: boolean;
  @Input() to: boolean;
  @Input() direction: string = 'right';
  @Input() action: string;
  @Input() data: any[] = null;

  // Public Variables
  public showRequirements: boolean;

  constructor() {}

  ngOnInit() {

  }

  mouseEnter() {
    this.showRequirements = true;
  }

  mouseLeave() {
    this.showRequirements = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/lock-status/lock-status.component.ts